import Image from "next/image";

import buildCreditHistory from "./credit_history.png";
import earnCashBack from "./earn_cash_back.svg";
import inNetworkAtm from "./in_network_atms.svg";
import overdraftProtection from "./overdraft_protection.svg";
import paidEarly from "./paid_early.png";

import styles from "./styles.module.scss";

function Perks() {
  return (
    <section className={styles["perks-section"]}>
      <div className={styles["perk"]}>
        <div className={styles["image-wrapper"]}>
          <Image
            alt="Earn cash back"
            className={styles["perk-image"]}
            src={earnCashBack}
          />
        </div>
        <div className={styles["text-wrapper"]}>
          <h2 className={`text:heading-2 ${styles["perk-title"]}`}>
            Earn cash back
          </h2>
          <p className={styles["perk-content"]}>
            Whether it’s groceries, shopping, or dining, we’ll immediately
            credit you the cash back you’ve earned.<sup>2</sup>
          </p>
        </div>
      </div>
      <div className={styles["perk"]}>
        <div className={styles["image-wrapper"]}>
          <Image
            alt="Overdraft protection"
            className={styles["perk-image"]}
            src={overdraftProtection}
          />
        </div>
        <div className={styles["text-wrapper"]}>
          <h2 className={`text:heading-2 ${styles["perk-title"]}`}>
            Fee-free overdraft protection
          </h2>
          <p className={styles["perk-content"]}>
            With qualifying direct deposits, overdraw $20 per month on your card
            without fees. The amount will increase the longer you keep your
            banking service with Kikoff, up to $200 per month.<sup>3</sup>
          </p>
        </div>
      </div>
      <div className={styles["perk"]}>
        <div className={styles["image-wrapper"]}>
          <Image
            alt="Deposit paid early notification"
            className={styles["perk-image"]}
            src={paidEarly}
          />
        </div>
        <div className={styles["text-wrapper"]}>
          <h2 className={`text:heading-2 ${styles["perk-title"]}`}>
            Get paid early
          </h2>
          <p className={styles["perk-content"]}>
            You shouldn’t have to wait for the money you’ve earned. Set up
            direct deposit and have your paycheck ready to use up to 2 days
            early.<sup>4</sup>
          </p>
        </div>
      </div>
      <div className={styles["perk"]}>
        <div className={styles["image-wrapper"]}>
          <Image
            alt="Credit score points gained"
            className={styles["perk-image"]}
            src={buildCreditHistory}
          />
          <span className={styles["perk-note"]}>
            Image is for illustrative purpose only
          </span>
        </div>
        <div className={styles["text-wrapper"]}>
          <h2 className={`text:heading-2 ${styles["perk-title"]}`}>
            Build credit with your banking service
          </h2>
          <p className={styles["perk-content"]}>
            Build credit history<sup>5</sup> at the three credit bureaus with a
            minimum deposit of $50
          </p>
        </div>
      </div>

      <div className={styles["perk"]}>
        <div className={styles["image-wrapper"]}>
          <Image
            alt="No ATM-fees at in-network ATMs"
            className={styles["perk-image"]}
            src={inNetworkAtm}
          />
        </div>
        <div className={styles["text-wrapper"]}>
          <h2 className={`text:heading-2 ${styles["perk-title"]}`}>
            In-Network Fee-free ATMs
          </h2>
          <p className={styles["perk-content"]}>
            Use your physical card to withdraw cash without fees at any of the
            55,000 Allpoint ATMs<sup>6</sup> worldwide.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Perks;
